var logError = require('./error');
var resourceHelpers = require('./resourceHelpers.js')

var FusionContentDocLoader = function(root, dataManager, config) {
    this.root = root;
    this.dataManager = dataManager;
    this.config = config;
};
module.exports = FusionContentDocLoader;

FusionContentDocLoader.prototype.openDocument = function(doc_options, nodesToSkip) {
    var self = this;

    // find way to get ID from C++ to load data

    var assetPromise = Promise.resolve();

    this.readOnly = doc_options.readOnly;
    this.fakeData = false;

    // if no id provided, create a new asset, and set the id.
    if(!doc_options.id){
        if(doc_options.createNew){
            assetPromise = assetPromise.then(function() {
                return self.createNewResource(doc_options)
            })
            .then(function(res) {
                doc_options.id = res["id"];
            });
        } else {
            this.createFakeResource(doc_options);
            self.fakeData = true;
        }
    }

    if(this.fakeData) return assetPromise;
    // no need for further loading

    // now I get the data
    assetPromise = assetPromise.then(function() {
        return self.dataManager.getResource(doc_options.assetType, doc_options.id);
    });

    // now I check if I have write access
    assetPromise = assetPromise.then(function(asset) {
        if(asset.hasUserWritePermissions() || self.readOnly) {
            return asset;
        } else {
          doc_options.reloadEditor(doc_options.id, 2)
        }
    });

    // now I set everything
    assetPromise = assetPromise.then(function(resource){
        if(!resource){
            self.createFakeResource(doc_options);
            return;
        }

        self.root.asset = resource;
        var savepoint = resourceHelpers.getMostRecentSavepoint(resource, ["savedSnapshot", "draft"]);
        if(savepoint == -1){
              if(resource.sharejs_id && !self.readOnly){
                  // if there is a doc, migrate it.
                  // after migration there will be a savpoint, so we won't end up here again.
                  // don't migrate if read-only, the CS may deny you.
                  return self.getMigratedCollabDoc(doc_options.assetType, doc_options.id, self.config.datamodel.datamodel_version, nodesToSkip);
              } else {
                  return self.makeNewCollabDoc(doc_options);
              }

        } else {
            // version won't be provided by fusion

            let isDraft = savepoint.type == "draft";

            if(self.readOnly){
                let lastVersion = resourceHelpers.getMostRecentSavepoint(resource, ["savedSnapshot"]);

                if(lastVersion == -1){
                    // we have a draft but no snapshot (ie fork) and are in read only with no version.
                    // we can't show the current draft, that would reveal too much data for read only mode.
                    // we can just show empty collab doc tho, since saving can't happen in read only
                    return self.makeNewCollabDoc(doc_options);

                } else {
                    return self.getSnapshot(doc_options.assetType, doc_options.id, lastVersion.version, self.config.datamodel.datamodel_version, nodesToSkip)
                }


            } else if(!isDraft && resourceHelpers.shouldMigrateCollabDoc(resource)){
                return self.getMigratedCollabDoc(doc_options.assetType, doc_options.id, self.config.datamodel.datamodel_version, nodesToSkip);

            } else {
                return self.getCollabDoc(doc_options.assetType, doc_options.id, self.config.datamodel.datamodel_version, nodesToSkip, isDraft);
            }
        }
    })

    return assetPromise;
};

FusionContentDocLoader.prototype.createFakeResource = function(doc_options){
  let self = this;
  self.root.asset = {
    id: -1,
    name: "",
    getLastVersion: function(){return false},
    getVersions: function(){return []}
  }

  if(doc_options.data){
    self.root.header = doc_options.data["header"];
    let data = self.root.dejsonify(doc_options.data["body"]);   // dejsonify the body in this root as an observable and shared datamodel
    self.root.attachData(data);
  } else {
    let data = new doc_options.dataClass(true);
    self.root.attachData(data);
  }
  return;
}

FusionContentDocLoader.prototype.createNewResource = function(doc_options) {
    var self = this;
    var assetType = doc_options.assetType;
    var capitalizedAssetType = assetType.charAt(0).toUpperCase() + assetType.slice(1);
    var emptyResource = {
        "name": "New "+capitalizedAssetType,
        "description": "",
        "tags": [],
        "score": 0,
        "hub": doc_options.hub
    };
    if(doc_options.assetType == "library"){ emptyResource['assets'] = []; } // TODO: this doesn't belong here!
    return self.dataManager.createResource(emptyResource, doc_options.assetType);
};


FusionContentDocLoader.prototype.getSnapshot = function(type, id, version, dm_v, nodesToSkip){
	var self = this;
	return self.dataManager.getResourceSnapshot(type, id, version, dm_v)
    .then(function(json){
    	self.root.header = json["header"];   // save the header directly in the root: header is not observable and read-only
		  var data = self.root.dejsonify(json["body"], nodesToSkip);   // dejsonify the body in this root as an observable and shared datamodel
		  self.root.attachData(data);
    })
}


FusionContentDocLoader.prototype.getCollabDoc = function(type, id, dm_v, nodesToSkip, isDraft){
    var self = this;
    return self.dataManager.getResourceColabDoc(type, id, dm_v)
    .then(function(json){
        self.root.header = json["header"];   // save the header directly in the root: header is not observable and read-only
        var data = self.root.dejsonify(json["body"], nodesToSkip);   // dejsonify the body in this root as an observable and shared datamodel
        self.root.attachData(data);
        if(isDraft) self.root.wasChanged();
    })
}


FusionContentDocLoader.prototype.getMigratedCollabDoc = function(type, id, dm_v, nodesToSkip){
    var self = this;
    return self.dataManager.migrateCollabDocToDraft(type, id, dm_v)
    .then(function(json){
        self.root.header = json["header"];   // save the header directly in the root: header is not observable and read-only
        var data = self.root.dejsonify(json["body"], nodesToSkip);   // dejsonify the body in this root as an observable and shared datamodel
        self.root.attachData(data);
        self.root.wasChanged();
    })
}

FusionContentDocLoader.prototype.makeNewCollabDoc = function(doc_options){
	var self = this;
	return self.dataManager.getEmptyColabDoc(doc_options.assetType, doc_options.id, self.config.datamodel.datamodel_version)
	.then(function(res){
		self.root.header = {
	        "assetId" : res["header"]["assetId"],
	        "assetType" : res["header"]["assetType"],
	        "datamodel_version": res["header"]["datamodel_version"]
	    };
        var data = new doc_options.dataClass(true);
        self.root.attachData(data);
	})
}
